/**
 * Données du site public (sans connexion) : chiffres réels de la plateforme pour la page d'accueil.
 */
import { http } from "./http";

export interface PublicStats {
  /** Écoles actives. */
  schools: number;
  /** Élèves inscrits sur l'année active de chaque école. */
  students: number;
  teachers: number;
}

export function getPublicStats(): Promise<PublicStats> {
  return http.get<PublicStats>("/public/stats");
}
